import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
const ScrollView = forwardRef((props, ref) => (React.createElement(Container, { ...props, ref: ref })));
ScrollView.displayName = 'ScrollView';
export default ScrollView;
const Container = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;
